import styles from "./index.module.css";

export const FlexLayout = ({ className, style, children, justifyContent }) => (
  <div style={{ ...style, justifyContent }} className={`${styles.container} ${className}`}>
    {children}
  </div>
);
